'use strict';

const FeatureUtil = {
    hasActivityShareLink: function(channelFeatures={}) {
        return !!channelFeatures.activityShareLink;
    },

    hasAdHocAssignments: function(channelFeatures={}) {
        return !!channelFeatures.adHocAssignments;
    },

    hasBasicAnalytics: function(channelFeatures={}) {
        return !!channelFeatures.basicAnalytics;
    },

    hasCaliperAnalytics: function(channelFeatures={}) {
        return !!channelFeatures.caliperAnalytics;
    },

    hasDetailedAnalytics: function(channelFeatures={}) {
        return !!channelFeatures.detailedAnalytics;
    },

    hasExportAssignmentResults: function(channelFeatures={}) {
        return !!channelFeatures.exportAssignmentResults;
    },

    hasGoogleClassroom: function(channelFeatures={}) {
        return !!channelFeatures.googleClassroom;
    },

    hasGroups: function(channelFeatures={}) {
        return !!channelFeatures.createGroups;
    },

    hasIntegrationTags: function(channelFeatures={}) {
        return !!channelFeatures.activityTags || !!channelFeatures.projectTags;
    },

    hasActivityMetaTags: function(channelFeatures={}) {
        return !!channelFeatures.activityMetaTags;
    },

    hasLTI: function(channelFeatures={}) {
        return !!channelFeatures.lti;
    },

    hasPrivacyPolicies: function(channelFeatures={}) {
        return !!channelFeatures.privacyPolicies;
    },

    hasPersonalChannel: function(channelFeatures={}) {
        return !!channelFeatures.personalChannel;
    },

    /*hasShortCourses: function(channelFeatures={}) {
        return !!channelFeatures.shortCourses;
    },*/
};

module.exports = FeatureUtil;